import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const LINKEDIN_PARTNER_ID = '9671938';
export const LINKEDIN_INSIGHT_SRC = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

type LinkedInTrk = {
  (action: string, data?: Record<string, unknown>): void;
  q: unknown[];
};

declare global {
  interface Window {
    _linkedin_partner_id?: string;
    _linkedin_data_partner_ids?: string[];
    lintrk?: LinkedInTrk;
  }
}

function insightScriptPresent() {
  return Boolean(document.querySelector(`script[src="${LINKEDIN_INSIGHT_SRC}"]`));
}

function installLinkedInInsightTag() {
  window._linkedin_partner_id = LINKEDIN_PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  if (!window._linkedin_data_partner_ids.includes(LINKEDIN_PARTNER_ID)) {
    window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);
  }

  if (typeof window.lintrk !== 'function') {
    const lintrk = ((action: string, data?: Record<string, unknown>) => {
      lintrk.q.push([action, data]);
    }) as LinkedInTrk;
    lintrk.q = [];
    window.lintrk = lintrk;
  }

  if (insightScriptPresent()) {
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = LINKEDIN_INSIGHT_SRC;
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
}

let lastTrackedPath: string | null = null;

export function resetLinkedInInsightTag() {
  lastTrackedPath = null;
}

/**
 * LinkedIn Insight Tag. The official snippet in index.html records the
 * first page view; later SPA navigations call lintrk('track').
 */
const LinkedInInsightTag = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    installLinkedInInsightTag();
    if (lastTrackedPath === pathname) {
      return;
    }
    if (lastTrackedPath !== null) {
      window.lintrk?.('track');
    }
    lastTrackedPath = pathname;
  }, [pathname]);

  return null;
};

export default LinkedInInsightTag;
